module.exports = __webpack_public_path__ + "img/ykt_summary_Image.2f3d2383.png";